import React from 'react';
import Select from 'react-select';

const ItensSelect = ({ value, setValue, filter, text }) => {
    return (
        <Select
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: 'rgb(71 85 105)',
                }),
            }}
            theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                colors: {
                    ...theme.colors,
                    primary25: 'rgb(91 105 125)', // Hover list
                    primary: 'rgb(101 125 135)', // Border select
                    neutral0: 'rgb(71 85 105)', // Banner com as opções
                    neutral10: 'rgb(151 165 185)', // Item select
                    neutral40: 'rgb(200 230 250)', // Text banner
                    neutral60: 'rgb(151 165 185)', // Clean campo
                    neutral90: 'green',
                    neutral80: 'rgb(230 230 230)', // Text
                    neutral50: 'rgb(200 200 200)', // Placeholder
                },
            })}
            onChange={(selectedOptions) => {
                setValue(
                    selectedOptions.map((item) => ({
                        id: item.value,
                        tipo: item.label,
                    }))
                );
            }}
            isMulti
            closeMenuOnSelect={true} // Garante que a bandeja feche ao selecionar
            options={value.map((item) => ({
                value: item.id,
                label: item.tipo || item.raridade || item.nome,
            }))}
        />
    );
};

export default ItensSelect;
